

import {Options, Vue} from "vue-class-component";

@Options({})
export default class LoadingSpinner extends Vue {

  constructor(props) {
    super(props);
  }

}
